import styled from 'styled-components';
import { darken } from 'polished';
import GWalletPT from '../../../assets/images/wallet-pt.png';
import GWalletEN from '../../../assets/images/wallet-en.png';
import GWalletES from '../../../assets/images/wallet-es.png';

const i18Styles = {
  pt: {
    button: GWalletPT,
    height: '40px',
  },
  en: {
    button: GWalletEN,
    height: '53px',
  },
  es: {
    button: GWalletES,
    height: '50px',
  },
};

export const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  background-color: ${props => props.$secondaryColor};
  opacity: 0;
  animation: fadeInPage 0.3s ease-in-out forwards;

  @keyframes fadeInPage {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const InviteWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    max-width: 480px;
  }
`;

export const InviteContentWrapper = styled.div`
  width: 100%;
  flex: 1;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  background: linear-gradient(
    to bottom,
    ${props => props.secondaryColor} 0%,
    ${props => props.secondaryColor} 100%
  );
`;

export const Cover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-size: 20px;
  color: ${props => props.theme.colors.secondary600};
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 16px;
  margin-top: auto;
`;

export const PoweredByText = styled.span`
  font-size: 16px;
  color: ${props => props.color};
  font-weight: 400;
`;

export const GoogleWalletButton = styled.button`
  background-image: url(${props => i18Styles[props.lang].button});
  background-color: transparent;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: ${props => i18Styles[props.lang].height};
  width: 300px;
  color: ${props => props.theme.colors.white};
  text-decoration: underline;
  border: none;
  &:hover {
    color: ${props => darken(0.05, props.theme.colors.white)};
  }
  &:focus {
    outline: 0;
  }
  &.disabled {
    pointer-events: none;
    opacity: 0.65;
    &::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      margin: -10px;
      border: 4px solid ${props => props.theme.colors.white};
      border-top-color: ${props => props.theme.colors.porterPrimary};
      border-radius: 50%;
      animation: button-loading-spinner 1s ease infinite;
    }
  }
  @keyframes button-loading-spinner {
    from {
      transform: rotate(0turn);
    }

    to {
      transform: rotate(1turn);
    }
  }
`;

export const SmartLockCtaWrapper = styled.div`
  align-self: stretch;
  padding: 0 16px;
`;
